import { render, staticRenderFns } from "./NumberCell.vue?vue&type=template&id=5ad63670&scoped=true"
import script from "./NumberCell.vue?vue&type=script&lang=js"
export * from "./NumberCell.vue?vue&type=script&lang=js"
import style0 from "./NumberCell.vue?vue&type=style&index=0&id=5ad63670&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ad63670",
  null
  
)

export default component.exports